import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Fabric } from '@app/models/order/work-order';
import { ApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class FabricProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/fabric/fabric-code';

  public batchFabrics(fabricCodes: string[]): Observable<ApiResponse<Fabric[]>> {
    return this.httpClient.post<ApiResponse<Fabric[]>>(this.baseUrl + '/batch', fabricCodes);
  }
}
